// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_dn-3";
export var flatBottomCorners = "_dn-5";
export var productImage = "_dn-0";
export var quantityContainer = "_dn-2";
export var quantityHeader = "_dn-6";
export var tooltip = "_dn-1";
export var wrapAndEllipsesOverflow = "_dn-4";